import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=4e369932&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=ts&"
export * from "./AddressList.vue?vue&type=script&lang=ts&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=4e369932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e369932",
  null
  
)

export default component.exports